// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as PretendAsCallerRepoManager from "../repo/PretendAsCallerRepoManager.bs.js";

function execute(param, onSuccess, onFailure, country) {
  var RepoInstance = PretendAsCallerRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param$1) {
                return Curry._2(RepoInstance.fetchCallerDetails, param, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

export {
  execute ,
  
}
/* PretendAsCallerRepoManager Not a pure module */
